<script setup lang="ts">
import type { AssessmentTemplateListRow } from '../../model/assessments/interfaces'

import { faBoxArchive, faCopy, faPen, faRotateLeft, faTrashCan } from '@fortawesome/pro-regular-svg-icons'

import { AppDropdown, AppDropdownItem } from '@shared/ui/dropdowns'
import { BtnIcon } from '@shared/ui/buttons'

import { useAssessmentTemplateActions } from '../../model/assessments/assessment-template-actions.hook'

defineOptions({
  name: 'AssessmentTemplateActions',
})

const props = defineProps<{
  template: AssessmentTemplateListRow
}>()

const {
  isOpen,
  containerRef,
  floatingRef,
  floatingStyles,
  triggerIcon,
  canManage,
  refIsArchived,
  refIsChangingStatus,
  toggle,
  openEdit,
  openDuplicate,
  openDelete,
  archive,
  unarchive,
} = useAssessmentTemplateActions({
  template: computed(() => props.template),
})
</script>

<template>
  <div
    ref="containerRef"
    class="assessment-template-actions"
  >
    <BtnIcon
      :icon="triggerIcon"
      view="table"
      :title="`Actions for ${template.title}`"
      @click="toggle"
    />
    <div
      v-if="isOpen"
      ref="floatingRef"
      class="assessment-template-actions__floating"
      :style="floatingStyles"
    >
      <AppDropdown>
        <AppDropdownItem
          text="Edit"
          color="blue"
          :prepend-icon="faPen"
          @click="openEdit"
        />
        <AppDropdownItem
          v-if="canManage"
          text="Duplicate"
          color="blue"
          :prepend-icon="faCopy"
          @click="openDuplicate"
        />
        <!-- No "Publish" here: the row carries no document to validate against. The editor owns it. -->
        <AppDropdownItem
          v-if="canManage && !refIsArchived"
          text="Archive"
          color="blue"
          :prepend-icon="faBoxArchive"
          :disabled="refIsChangingStatus"
          @click="archive"
        />
        <AppDropdownItem
          v-if="canManage && refIsArchived"
          text="Unarchive as draft"
          color="blue"
          :prepend-icon="faRotateLeft"
          :disabled="refIsChangingStatus"
          @click="unarchive"
        />
        <AppDropdownItem
          v-if="canManage"
          text="Delete"
          color="red"
          :prepend-icon="faTrashCan"
          @click="openDelete"
        />
      </AppDropdown>
    </div>
  </div>
</template>

<style scoped lang="scss" src="./AssessmentTemplateActions.scss" />
